// React
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Containers
import { ModalDelete } from '../../containers/componentsInjection';

export const FileAttachmentCard = ({ fileName, fileLink, handleDelete }) => {
  const [isOpen, setIsOpen] = useState(false);

  function toggle() {
    setIsOpen(!isOpen);
  }

  function handleDownload() {
    window.open(fileLink, '_blank');
  }

  return (
    <React.Fragment>
      <div className="vstack gap-2">
        <div className="border rounded border-dashed p-2">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0 me-3">
              <div className="avatar-sm">
                <div className="avatar-title bg-light text-secondary rounded fs-24">
                  <i className="ri-file-text-line"></i>
                </div>
              </div>
            </div>
            <div className="flex-grow-1 overflow-hidden">
              <h5 className="fs-13 mb-1">
                <Link to="#" className="text-body text-truncate d-block">
                  {fileName}
                </Link>
              </h5>
            </div>
            <div className="flex-shrink-0 ms-2">
              <div className="d-flex gap-1">
                {fileLink && (
                  <button
                    type="button"
                    onClick={handleDownload}
                    className="btn btn-icon text-muted btn-sm fs-18"
                  >
                    <i className="ri-download-2-line"></i>
                  </button>
                )}
                <button
                  type="button"
                  onClick={toggle}
                  className="btn btn-icon text-danger btn-sm fs-18"
                >
                  <i className="ri-delete-bin-fill"></i>{' '}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalDelete
        isOpen={isOpen}
        toggle={toggle}
        goBack={toggle}
        handleDelete={handleDelete}
      />
    </React.Fragment>
  );
};
